import { isEmpty } from 'lodash';
import { useRecoilValue } from 'recoil';

import { Text } from '@/components/text';
import { MODE_WATER } from '@/lib/constants';
import { getLocationNameWithCode } from '@/lib/models/location/get-location-name-with-code';
import { getLocationsByIdState } from '@/state/locations';
import { SegmentModeType } from '@/types/api-types';
import { tv } from '@/utils/styles';

export interface JourneyLegEventsProps {
  events?: string[];
  mode: SegmentModeType;
}

const JourneyLegEvents = ({ events = [], mode }: JourneyLegEventsProps) => {
  const locations = useRecoilValue(getLocationsByIdState(events));

  if (isEmpty(locations)) return null;

  const stopString = locations
    .map((location) => {
      const { name, code } = getLocationNameWithCode(location);
      return `${code} (${name})`;
    })
    .join(', ');
  const stopTypeString = mode === MODE_WATER ? 'Calls in at' : 'Stops at';

  const { base, stopMarker } = styles();

  return (
    <div className={base()}>
      <span className={stopMarker()} />
      <Text variant="sm" className="mb-0">
        {stopTypeString} <b className="font-medium">{stopString}</b>
      </Text>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'relative mt-6',
    stopMarker: 'absolute -left-[35px] top-1 block h-2.5 w-2.5 rounded-full bg-white opacity-70',
  },
});

export { JourneyLegEvents };
